import initialState from '../../core/initialState';
import Event from '../../core/Event';
import OrdersFilterSelected from '../events/OrdersFilterSelected';
import OrdersFilterRemoved from '../events/OrdersFilterRemoved';
import orderChangeConfirmed from './orderChangeConfirmed';
import { addFilterToArray, removeFilterFromArray } from '../../core/arrayOperations';
import OrderProductsSearchRequested from '../events/OrderProductsSearchRequested';
import OrderCurrentReceived from '../events/OrderCurrentReceived';
import State, { PlacingOderStatus } from '../State';
import SaveOrderDraftSucceed from '../events/OrderSaveDraftSucceed';
import OrderDetailsReceived from '../events/OrderDetailsReceived';
import OrderChangeConfirmed from '../events/OrderChangeConfirmed';
import OrderDeliveryFeeReceived from '../events/OrderDeliveryFeeReceived';
import OrderPlaceRequestSent from '../events/OrderPlaceRequestSent';
import OrderPlaceSucceed from '../events/OrderPlaceSucceed';
import OrderPlaceFailed from '../events/OrderPlaceFailed';
import OrderSetBaseOnLiabilitySucceed from '../events/OrderSetBaseOnLiabilitySucceed';
import applyEstimationLevels from './applyEstimationLevels';
import OrderImportSucceed from '../events/OrderImportSucceed';
import { ArticleOrderDraft, ItemOrderDraft } from '../../../domain/Order';

export default (state: State = initialState.order, anyEvent: Event): State => {
    switch (anyEvent.type) {
        case OrderPlaceRequestSent.type: {
            return {
                ...state,
                placingOrderStatus: PlacingOderStatus.Progress
            };
        }

        case OrderPlaceFailed.type: {
            return {
                ...state,
                placingOrderStatus: PlacingOderStatus.Null
            };
        }
        case OrderPlaceSucceed.type: {
            return {
                ...state,
                order: {
                    ...state.order!,
                    articlesOrdersDrafts: []
                },
                placingOrderStatus: PlacingOderStatus.Null
            };
        }
        case OrderCurrentReceived.type:
            const event: OrderCurrentReceived = anyEvent as OrderCurrentReceived;
            return {
                ...state,
                order: event.order,
                savedOrder: event.order,
                articlesEstimations: event.articlesEstimations,
                orderedSku: event.orderedSku,
                deliveryFee: 0,
                liabilityMet: event.liabilityMet,
                orderedStock: event.orderedStock,
                orderedCheckout: event.orderedCheckout,
                estimated: event.estimated
            };
        case SaveOrderDraftSucceed.type: {
            return {
                ...state,
                savedOrder: (anyEvent as SaveOrderDraftSucceed).order
            };
        }
        case OrderChangeConfirmed.type:
            return orderChangeConfirmed(state, anyEvent as OrderChangeConfirmed);
        case OrdersFilterSelected.type: {
            return {
                ...state,
                orderFilters: addFilterToArray(state.orderFilters, (anyEvent as OrdersFilterSelected).filter)
            };
        }
        case OrdersFilterRemoved.type: {
            return {
                ...state,
                orderFilters: removeFilterFromArray(state.orderFilters, (anyEvent as OrdersFilterRemoved).filter)
            };
        }
        case OrderProductsSearchRequested.type: {
            return {
                ...state,
                searchQuery: (anyEvent as OrderProductsSearchRequested).query
            };
        }
        case OrderDetailsReceived.type: {
            return {
                ...state,
                orderDetails: (anyEvent as OrderDetailsReceived).orderDetails
            };
        }
        case OrderDeliveryFeeReceived.type: {
            return {
                ...state,
                deliveryFee: (anyEvent as OrderDeliveryFeeReceived).deliveryFee
            };
        }
        case OrderSetBaseOnLiabilitySucceed.type: {
            return {
                ...state,
                order: {
                    ...state.order!,
                    articlesOrdersDrafts: applyEstimationLevels(
                        (anyEvent as OrderSetBaseOnLiabilitySucceed).articleOrderDrafts,
                        state.order!.articlesOrdersDrafts
                    )
                }
            };
        }
        case OrderImportSucceed.type: {
            const importEvent: OrderImportSucceed = anyEvent as OrderImportSucceed;
            return {
                ...state,
                order: {
                    ...state.order!,
                    articlesOrdersDrafts: importEvent.orders.map((a: ArticleOrderDraft) => ({
                        ...a,
                        itemsOrdersDrafts: a.itemsOrdersDrafts.map((i: ItemOrderDraft) => ({
                            ...i,
                            toOrderFromEstimation: i.toOrderFromEstimation === null ? 0 : i.toOrderFromEstimation,
                            toOrderFromStock: i.toOrderFromStock === null ? 0 : i.toOrderFromStock
                        }))
                    }))
                }
            };
        }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/order/reducer/index.ts